import "./guide.css"
import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';

export const GuideDetailModal = ({ isOpen, isClosing, onClose, children }) => {
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Delay to trigger transition after mount
      requestAnimationFrame(() => {
        setAnimateIn(true);
      });
    } else {
      setAnimateIn(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={`modal-overlay ${isOpen ? 'show' : ''}`}
      onClick={onClose}
    >
      <div
        className={`modal-content ${animateIn ? 'slide-up' : ''} ${isClosing ? 'slide-down' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};